export default "__VITE_ASSET__BanftKK6__"